import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from './shared/toast-container/toast-container.component';
import { AppVersionPanelComponent } from './shared/app-version-panel/app-version-panel.component';
import { AuthService } from './services/auth.service';
import { environment } from '../environments/environment';

const CDN_LOGO_PATH = '/public/_app/features/generic/logo';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastContainerComponent, AppVersionPanelComponent],
  templateUrl: './app.component.html'
})
export class AppComponent {
  private titleService = inject(Title);
  private auth = inject(AuthService);

  constructor() {
    const cdnBaseUrl = environment.AH_DASH_FE_CDN_01_FULL_URL.replace(/\/+$/, '');
    const iconUrl = `${cdnBaseUrl}${CDN_LOGO_PATH}/arcade-engine-icon.png`;
    const logoUrl = `${cdnBaseUrl}${CDN_LOGO_PATH}/arcade-haus-logo.png`;

    this.appendAssetLink('icon', iconUrl, 'image/png');
    this.appendAssetLink('preload', logoUrl, 'image/png', 'image');
    this.appendAssetLink('preload', iconUrl, 'image/png', 'image');
    this.titleService.setTitle(environment.AH_DASH_FE_02_PUBLIC_NAME);

    if (!environment.IS_FAKE_SHOWCASE && this.auth.user()) {
      this.auth.refreshSession().subscribe();
    }
  }

  private appendAssetLink(rel: string, href: string, type: string, as?: string): void {
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    link.type = type;

    if (as) {
      link.as = as;
    }

    document.head.appendChild(link);
  }
}
